import ButtonsToGenerateReports from '@/components/Reports/ButtonsToGenerateReports';
import DirectSaleForm from '@/components/Reports/MovementReports/DirectSaleForm';
import { DefaultRouteTabs } from '@/components/_common';
import useCommonGenerateReport from '@/core/domain/reports/commons/Report.hook';
import {
  ReportDirectSaleRequest,
  ReportDirectSaleSaleSummaryFormValues,
  ReportTypeEnum,
} from '@/core/domain/reports/financial/directSale/DirectSale.types';
import useFileLoading, { FILE_FORMAT, FileType } from '@/hooks/useFileLoading';
import { ReportCallback } from '@/hooks/useReportGenerate';
import { useReportHandlers } from '@/hooks/useReportHandler';
import { PageProps } from '@/types/PageProps';
import { Divider, Form } from 'antd';
import moment from 'moment';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

export default function MovementDirectSalePage({ route }: PageProps) {
  const intl = useIntl();
  const [form] = Form.useForm<ReportDirectSaleSaleSummaryFormValues>();
  const { setFileLoading, setFileUnloading, fileLoading } = useFileLoading();

  const generateReport = useCommonGenerateReport(
    '/generate/' +
      form.getFieldsValue().reportType +
      (form.getFieldsValue().synthetic &&
      form.getFieldsValue().reportType === ReportTypeEnum.SalesSeller
        ? '-synthetic'
        : ''),
    'Relatório gerado com sucesso!',
    'Relatório de venda direta gerado com sucesso.',
  );

  const handleGenerateReport = async (
    format: FileType,

    callback?: ReportCallback,
  ) => {
    setFileLoading(format);
    try {
      const values: ReportDirectSaleSaleSummaryFormValues =
        await form.validateFields();
      const obj: Omit<ReportDirectSaleRequest, 'reportType'> = {
        companiesIds: values.companiesIds,
        lsSituacao: values.lsSituacao,
        dateType: values.dateType,
        tagsIds: values.tagsIds,
        employeesIds: values.employeesIds,
        customersIds: values.customersIds,
        initialDate: moment(values.initialDate).format('YYYY-MM-DD'),
        finalDate: moment(values.finalDate).format('YYYY-MM-DD'),
        format: FILE_FORMAT[format],
      };

      const result = await generateReport.mutateAsync(
        values.reportType === ReportTypeEnum.SalesSummary
          ? { ...obj, groupBySaleSummary: values.groupBySaleSummary }
          : obj,
      );

      if (callback) {
        callback(result);
      }
    } catch {}

    setFileUnloading(format);
  };

  const { handleView, handlePdf, handleCsv } = useReportHandlers(
    'relatorio_venda_direta',
    handleGenerateReport,
  );

  return (
    <DefaultRouteTabs route={route.parent} permissions={route.permissions}>
      <Helmet title={intl.formatMessage({ id: route.name })} />

      <DirectSaleForm form={form} />

      <Divider />

      <ButtonsToGenerateReports
        viewReport={handleView}
        generatePdf={handlePdf}
        generateCsv={handleCsv}
        loading={fileLoading}
      />
    </DefaultRouteTabs>
  );
}
